import { useNavigate } from '@tanstack/react-router';
import { useAuth } from '../../contexts/AuthContext';
import { LogOut } from 'iconoir-react';

export const SignOutButton: React.FC = () => {
  const { firebaseSignOut } = useAuth();
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await firebaseSignOut();
    window.localStorage.removeItem('emailForSignIn');
    navigate({ to: '/' });
  };
  return (
    <button id="signOut-button" type="button" onClick={() => handleSignOut()}>
      <LogOut />
    </button>
  );
};
